import * as Api from '../api/api';
import * as Models from '../model/models';
import * as _ from 'underscore';

declare var angular: any;

module OceBookingConfirmApp {
    "use strict";
    //declare var hoge: any;
    declare var apiBaseUrl: string;
    declare var defaultCrmShopId: string;
    declare var defaultCmsShopId: number;
    declare var defaultUnitId: number;
    declare var defaultDate: string;
    declare var defaultTime: string;
    declare var activitykey: string;
    declare var _gaq: any;
    declare var isInitialOpenCalender: boolean;
    declare var isEditmode: boolean;
    declare var isDeviceSp: boolean;

    class MainCtrl {
        apiClient: Api.OnlineBookingApi;
        master: Models.OnlineBookingMaster;

        bookingStatus: Models.BookedTimeStatus;
        dateIdxList: Array<number>;
        nextDateIdxList: Array<number>;
        timeIdxList: Array<number>;

        selectedRegion: Models.OnlineBookingRegion;
        selectedShop: Models.OnlineBookingShop;
        selectedDate: Date;
        selectedUnit: Models.OnlineBookingUnit;
        selectedTime: string;

        isShowError: boolean;

        LastName: string;
        FirstName: string;
        LastNameKana: string;
        FirstNameKana: string;
        Tel: string;
        Mail: string;


        skipIdx = 0;

        isNextWeek: boolean;
        isSubmited: boolean = false;

        constructor(private $scope: ng.IScope, private $http: ng.IHttpService) {
            //$http.defaults.cache = false;
            this.apiClient = new Api.OnlineBookingApi($http, null, apiBaseUrl);
            this.apiClient
                .onlineBookingGetMaster()
                .then(c => {
                    this.master = c.data;

                    if (isEditmode) {

                        if (defaultCmsShopId != null) {

                            this.selectedRegion = _(this.master.regions).find(c => _(c.shops).any((d: Models.OnlineBookingShop) => d.cmsShopId == defaultCmsShopId));
                            var defaultValue = _(this.master.regions).chain().map(c => c.shops).flatten().find((c: Models.OnlineBookingShop) => c.cmsShopId == defaultCmsShopId).value();
                            this.selectedShop = defaultValue;
                        }

                        if (defaultUnitId != null) {
                            this.selectedUnit = _(this.master.units).find(c => c.id == defaultUnitId)
                        }

                        if (defaultDate != null && defaultDate != "") {
                            this.selectedDate = <any>(defaultDate);
                            this.selectedTime = defaultTime;
                        }
                    }
                    else {
                        if (defaultCrmShopId != "") {
                            var defaultValue = _(this.master.regions).chain().map(c => c.shops).flatten().find((c: Models.OnlineBookingShop) => c.crmShopId == defaultCrmShopId).value();
                            this.selectedShop = defaultValue;

                            if (isInitialOpenCalender) {
                                setTimeout(() => {
                                    if (this.selectedShop != null) {
                                        this.showSchedule();
                                    }
                                }, 300);
                            }
                        }
                    }

                });

            this.dateIdxList = [0, 1, 2, 3, 4, 5, 6];
            this.nextDateIdxList = [7, 8, 9, 10, 11, 12, 13];
            this.timeIdxList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
        }


        shopChange() {
            this.selectedDate = null;
            this.selectedTime = null;
            this.bookingStatus = null;
            this.selectedUnit = null;
        }

        regionChange() {
            this.selectedShop = null;
            this.shopChange();
        }

        unselectDate() {
            this.selectedDate = null;
            this.selectedTime = null;
            this.closeDialog();
        }

        showSchedule() {
            this.openDialog();
            this.isNextWeek = false;
            this.skipIdx = 0;
            this.apiClient
                .onlineBookingGetBookingTimeStatus(this.selectedShop.cmsShopId, activitykey, {
                    params: {
                        _tick: new Date().getTime(),
                        cmsShopId: this.selectedShop.cmsShopId,
                        currentActivityKey: activitykey
                    }
                })
                .then(c => this.bookingStatus = c.data);
        }

        getDateIndexList(): number[] {
            var skipNum = 7;
            if (isDeviceSp) {
                skipNum = 3;
            }


            var dateItem = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
            var start = this.skipIdx * skipNum;
            var end = start + skipNum;
            return dateItem.slice(start, end);
        }

        prevDays() {
            this.skipIdx--;
        }
        nextDays() {
            this.skipIdx++;
        }

        hasPrevDays(): boolean {
            return this.skipIdx != 0;
        }

        hasNextDays(): boolean {
            if (isDeviceSp) {
                return this.skipIdx < 4;
            }
            else {
                return this.skipIdx < 1;
            }
        }

        getUnitList() {
            if (this.selectedShop == null)
                return null;

            return _(this.master.units).chain().filter(c => c.shopId == this.selectedShop.cmsShopId).sortBy(c => c.sorting).value();
        }

        closeDialog() {
            var modal = '#con1';
            $(modal).fadeOut('fast');
            $('.modal-overlay').fadeOut('fast', function () {
                // オーバーレイを削除
                $('.modal-overlay').remove();
            });
        }

        setReservationDateTime(dateIdx: number, timeIdx: number) {
            //   console.log(dateIdx, timeIdx);

            this.selectedDate = this.bookingStatus.dateList[dateIdx];
            this.selectedTime = this.bookingStatus.timeList[timeIdx];
            this.closeDialog();
        }

        submit() {
            this.isShowError = true;
            //TODO:Validate

            if (!isEditmode) {
                var validateResult = this.validate();

                if (!this.isNullOrEmpty(validateResult)) {

                    alert(validateResult);
                    return;
                }
            }

            if (this.isSubmited)
                return;
            this.isSubmited = true;
            if (!isEditmode) {
                _gaq.push(['_trackEvent', 'Booking', 'Reservation', 'PCBE']);
            }


            //TODO:FormSubmit(100ms 遅延させてみる)
            setTimeout(() => {
                var target = <any>document.getElementById("form1");
                target.method = "POST";
                target.submit();
            }, 100);

            
        }

        openDialog() {
            $('body').append('<div class="modal-overlay"></div>');
            // オーバーレイをフェードイン
            $('.modal-overlay').fadeIn('fast');

            // モーダルコンテンツのIDを取得
            var modal = '#con1';
            // モーダルコンテンツの表示位置を設定
            modalResize();
            // モーダルコンテンツフェードイン
            $(modal).fadeIn('fast');

            // 「.modal-overlay」あるいは「.modal-close」をクリック
            $('.modal-overlay').off().click(() => this.closeDialog());

            // リサイズしたら表示位置を再取得
            $(window).on('resize', function () {
                modalResize();
            });


            // モーダルコンテンツの表示位置を設定する関数
            function modalResize() {
                // ウィンドウの横幅、高さを取得
                var w = $(window).width();
                var h = $(window).height();

                // モーダルコンテンツの表示位置を取得
                var x = (w - $(modal).outerWidth(true)) / 2;
                var y = (h - $(modal).outerHeight(true)) / 2;

                // モーダルコンテンツの表示位置を設定
                $(modal).css({ 'left': x + 'px', 'top': y + 'px' });
            }
        }

        validate(): string {
            var str = "";

            var v1 = this.validateNames();
            var v2 = this.validateTelNumber();
            var v3 = this.validateMail();
            var v4 = this.validateSelectedDateTime();
            if (v1 != null) {
                str += v1 + "\r\n";
            }
            if (v2 != null) {
                str += v2 + "\r\n";
            }
            if (v3 != null) {
                str += v3 + "\r\n";
            }
            if (v4 != null) {
                str += v4;
            }
            return str;
        }

        isNullOrEmpty(str: string): boolean {
            if (str == null)
                return true;
            if (str == "")
                return true;
            return false;
        }

        validateNames(): string {

            if (this.isNullOrEmpty(this.FirstName) || this.isNullOrEmpty(this.LastName) || this.isNullOrEmpty(this.FirstNameKana) || this.isNullOrEmpty(this.LastNameKana)) {
                return "名前は必ず入力してください";
            }

            if (!/^[ぁ-ん]+$/.test(this.LastNameKana))
                return "姓(かな)は全角ひらがなで入力してください";

            if (!/^[ぁ-ん]+$/.test(this.FirstNameKana))
                return "名(かな)は全角ひらがなで入力してください";

            return null;
        }



        validateMail(): string {

            if (this.isNullOrEmpty(this.Mail))
                return "メールアドレスは必ず入力してください";
            if (!/^[\w.\-\+]+@[\w\-]+\.[\w.\-]+$/.test(this.Mail))
                return "メールアドレスの書式が不正です";
            return null;
        }

        validateTelNumber(): string {
            if (this.isNullOrEmpty(this.Tel))
                return "電話番号は必ず入力してください";
            if (!/^[0-9]+$/.test(this.Tel))
                return "電話番号は半角数字のみで入力してください";
            return null;
        }


        validateSelectedDateTime(): string {

            if (this.selectedDate == null || this.selectedTime == null)
                return null;

            var dateTimeStr = this.selectedDate.toString().replace("00:00:00", this.selectedTime + ":00");

            var selectedDate = new Date(dateTimeStr);
            var now = new Date();

            if (selectedDate < now) {
                return "過去の時間は予約できません";
            }

            return null;
        }

    }
    angular.module("OceBookingConfirmApp", [])
        .controller("MainCtrl", <any>MainCtrl);

}